// extracted by mini-css-extract-plugin
export default {"wrapper":"ilBHC2glKpi7Ur3YWCtO"};